import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { JbFormFieldContainerModule } from 'jb-component-library';

/**
 * @description Wrapper to format inputs and give it a title
 * @WhereIsItUsed
 * - group travel
 * - contact us
 */
@Component({
  selector: 'dot-form-field-wrapper',
  standalone: true,
  imports: [CommonModule, JbFormFieldContainerModule],
  templateUrl: './dot-form-field-wrapper.component.html',
  styleUrls: ['./dot-form-field-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'db',
  },
})
export class FormFieldWrapperComponent {
  @Input() title: string;
}
